import { supabase } from "./supabase";
import type { Oekt } from "./session";

/**
 * Teamet man står på — LET 1, LET 2, Kontrollrom A.
 *
 * DEN ENKELTE VELGER SELV, og det er ikke en forenkling. `01-domene.md`:
 * «turnusjusteringer og sykdom flytter folk fra dag til dag, og å legge
 * vedlikeholdet på koordinator ville vært mye arbeid for noe som endrer seg
 * hele tiden.»
 *
 * TEAMET ER INGEN TILGANGSGRENSE. Det styrer hvilke flater som DELES, ikke
 * hvem som får se hva — alle medlemmer leser alt i produksjonen uansett.
 * Ingen policy i basen nevner `unit_id`.
 */

export interface Team {
  readonly id: string;
  readonly navn: string;
  readonly slag: "let" | "vj" | "control_room";
}

export async function hentTeam(produksjonId: string): Promise<readonly Team[]> {
  if (supabase === null) return [];
  const { data, error } = await supabase
    .from("unit")
    .select("id, name, kind")
    .eq("production_id", produksjonId)
    .order("name", { ascending: true });
  if (error !== null || data === null) return [];
  return (data as unknown as Record<string, unknown>[]).map((r) => ({
    id: String(r["id"]),
    navn: String(r["name"]),
    slag: String(r["kind"]) as Team["slag"],
  }));
}

export async function hentMitt(oekt: Oekt): Promise<string | null> {
  if (supabase === null) return null;
  const { data, error } = await supabase
    .from("production_member")
    .select("unit_id")
    .eq("id", oekt.member.id)
    .maybeSingle();
  if (error !== null || data === null) return null;
  const v = (data as unknown as Record<string, unknown>)["unit_id"];
  return v == null ? null : String(v);
}

/** Tom streng betyr «ingen team». Det er en gyldig tilstand, ikke en feil. */
export async function velgTeam(oekt: Oekt, teamId: string): Promise<boolean> {
  if (supabase === null) return true;
  const { error } = await supabase
    .from("production_member")
    .update({ unit_id: teamId === "" ? null : teamId })
    .eq("id", oekt.member.id);
  return error === null;
}
